import api from "@/lib/api";

function H() {
  const c = document.cookie.split(";").map(x=>x.trim()).find(x=>x.startsWith("active_hotel_id="));
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return { headers: v ? { "X-Hocp-Hotel": v } : {} };
}

export const opsAPI = {
  dashboard:    () => api.get("/ops/v1/dashboard", H()).then(r=>r.data),
  feed:         (params={}) => api.get("/ops/v1/feed", { ...H(), params }).then(r=>r.data),
  publish:      (b) => api.post("/ops/v1/publish", b, H()).then(r=>r.data),

  notifications:(params={}) => api.get("/ops/v1/notifications", { ...H(), params }).then(r=>r.data),
  notifAction:  (id, b) => api.post(`/ops/v1/notifications/${id}/action`, b, H()).then(r=>r.data),
  readAll:      () => api.post("/ops/v1/notifications/read-all", null, H()).then(r=>r.data),

  tasks:        (params={}) => api.get("/ops/v1/tasks", { ...H(), params }).then(r=>r.data),
  createTask:   (b) => api.post("/ops/v1/tasks", b, H()).then(r=>r.data),
  updateTask:   (id, b) => api.patch(`/ops/v1/tasks/${id}`, b, H()).then(r=>r.data),

  announcements:(params={}) => api.get("/ops/v1/announcements", { ...H(), params }).then(r=>r.data),
  createAnn:    (b) => api.post("/ops/v1/announcements", b, H()).then(r=>r.data),
  deactivateAnn:(id) => api.delete(`/ops/v1/announcements/${id}`, H()).then(r=>r.data),

  broadcasts:   () => api.get("/ops/v1/broadcasts", H()).then(r=>r.data),
  createBc:     (b) => api.post("/ops/v1/broadcasts", b, H()).then(r=>r.data),

  mentions:     () => api.get("/ops/v1/mentions", H()).then(r=>r.data),
  subscriptions:() => api.get("/ops/v1/subscriptions", H()).then(r=>r.data),
  upsertSub:    (b) => api.put("/ops/v1/subscriptions", b, H()).then(r=>r.data),
  deleteSub:    (id) => api.delete(`/ops/v1/subscriptions/${id}`, H()).then(r=>r.data),
};

// SSE — auto-reconnect wrapper
export function opsSubscribe(onEvent) {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/ops/v1/stream`;
  let source = null; let closed = false;
  const connect = () => {
    if (closed) return;
    source = new EventSource(url, { withCredentials: true });
    source.onmessage = (ev) => {
      try { onEvent(JSON.parse(ev.data)); } catch {/* ignore */}
    };
    source.onerror = () => {
      source?.close();
      if (!closed) setTimeout(connect, 3000);   // reconnect w/ backoff
    };
  };
  connect();
  return () => { closed = true; source?.close(); };
}

export const PRIORITY_STYLE = {
  low:      "bg-slate-100 text-slate-500",
  normal:   "bg-slate-100 text-slate-600",
  high:     "bg-amber-100 text-amber-700",
  critical: "bg-rose-100 text-rose-700",
};

export const MODULE_META = {
  wae:     { label: "Workflow",       icon: "GitBranch",         accent: "text-fuchsia-300" },
  kops:    { label: "Kitchen",        icon: "ChefHat",           accent: "text-orange-300" },
  fnb:     { label: "F&B",            icon: "UtensilsCrossed",   accent: "text-amber-300" },
  supply:  { label: "Supply",         icon: "Package",           accent: "text-sky-300" },
  maint:   { label: "Maintenance",    icon: "Wrench",            accent: "text-violet-300" },
  hk:      { label: "Housekeeping",   icon: "Sparkles",          accent: "text-teal-300" },
  fo:      { label: "Front Office",   icon: "Hotel",             accent: "text-cyan-300" },
  finance: { label: "Finance",        icon: "Banknote",          accent: "text-emerald-300" },
  ai_ops:  { label: "AI Ops",         icon: "Radar",             accent: "text-hocp-gold" },
  ops:     { label: "Ops Hub",        icon: "BellRing",          accent: "text-hocp-gold" },
  sys:     { label: "System",         icon: "Cog",               accent: "text-slate-300" },
};

export function fmtDT(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }); }
  catch { return "—"; }
}

export function timeAgo(v) {
  if (!v) return "—";
  try {
    const secs = Math.round((Date.now() - new Date(v).getTime()) / 1000);
    if (secs < 60)    return `${secs}s ago`;
    if (secs < 3600)  return `${Math.round(secs/60)}m ago`;
    if (secs < 86400) return `${Math.round(secs/3600)}h ago`;
    return `${Math.round(secs/86400)}d ago`;
  } catch { return "—"; }
}

export const cls = "w-full h-10 px-3 rounded-lg border border-slate-200 bg-white text-[13px] outline-none focus:border-hocp-navy transition";
